import ReservationsView from "@/modules/reservations/view/ReservationsView";
import DashboardView from "@/modules/reservations/view/dashboard/DashboardView";
import Notes from "@/modules/reservations/view/notes/Notes";
import SaleSettingsView from "@/modules/reservations/view/sale-settings/SaleSettingsView";
import BidsView from "@/modules/reservations/view/bids/BidsView";
import PreBidsView from "@/modules/reservations/view/pre-bids/PreBidsView";

const routes = [
  {
    path: 'reservations/view/:id',
    component: ReservationsView,
    name: 'reservations.view',
    redirect: 'reservations/view/:id/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'reservations.dashboard',
        component: DashboardView
      }, {
        path: 'settings',
        name: 'reservations.settings',
        component: SaleSettingsView
      }, {
        path: 'bids',
        name: 'reservations.bids',
        component: BidsView
      },{
        path: 'pre-bids',
        name: 'reservations.pre-bids',
        component: PreBidsView
      }, {
        path: 'notes',
        name: 'reservations.notes',
        component: Notes
      },
    ]
  }
];

export {routes}
